import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletProfilesV2 } from 'services/CustomerService'
import { CustomerWalletProfile } from 'types/customers'
import { CurrencyInterface } from 'types/wallets'

export const IGNORED_CURRENCIES = ['FDUSD']

const selectCurrenciesFromProfiles = (
  profileResponse: CustomerWalletProfile,
  cryptoOnly: boolean
): CurrencyInterface[] => {
  if (!profileResponse?.profiles) return []

  const currenciesMap = new Map<string, CurrencyInterface>()

  profileResponse.profiles.forEach(profile => {
    const isFiat = profile.id.startsWith('fiat:')

    profile.currencies.forEach(currencyCode => {
      if (!currenciesMap.has(currencyCode)) {
        currenciesMap.set(currencyCode, {
          id: currencyCode,
          code: currencyCode,
          name: currencyCode,
          fiat: isFiat,
        })
      }
    })
  })

  const currencies = Array.from(currenciesMap.values()).sort((a, b) => a.code.localeCompare(b.code))

  if (cryptoOnly) {
    return currencies?.filter(currency => !currency.fiat)
  }

  return currencies
}

export const useSupportedCurrenciesQuery = (cryptoOnly = false) => {
  return useQuery({
    queryKey: reactQueryKeys.customerWalletProfiles(),
    queryFn: () => getWalletProfilesV2(),
    select: (response: CustomerWalletProfile) => selectCurrenciesFromProfiles(response, cryptoOnly),
  })
}
